var consts = {};

/**
 * Patient PERIOD type.
 */
consts.PERIOD_TYPE = {
  IF_NECESSARY: 0,
  CONTINUOUS_USE: 1
};

/**
 * Patient HISTORY type.
 */
consts.HISTORY_TYPE = {
  CREATED_AT: 0,
  INITIALIZED: 1,
  DEACTIVATED: 2,
  CYLINDER_CHANGE: 3,
  PRESCRIPTION_CHANGE: 4
};

/**
 * Patient STATUS.
 */
consts.STATUS = {
  NEW: 0,
  INITIALIZED: 1,
  DEACTIVATED: 2
};
module.exports = consts;